import { Link } from '@tanstack/react-router';
import { ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { LogoMark } from '@/components/brand/Logo';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-vt-bg p-vt-6">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_50%_at_50%_0%,rgba(13,59,102,0.08)_0%,transparent_60%)]"
      />
      <div className="relative z-10 max-w-md text-center">
        <div className="mb-vt-6 flex justify-center">
          <LogoMark size={48} />
        </div>
        <p className="mb-vt-2 text-vt-12 font-semibold uppercase tracking-[0.12em] text-vt-primary">404</p>
        <h1 className="mb-vt-3 text-vt-32 font-semibold tracking-[-0.02em] text-vt-text">Page not found</h1>
        <p className="mb-vt-6 text-vt-14 leading-relaxed text-vt-text-muted">
          The page you are looking for has moved or never existed. Try the dashboard, or use the search bar in
          the top navigation.
        </p>
        <div className="flex justify-center gap-vt-2">
          <Button variant="secondary" asChild>
            <a href="javascript:history.back()" aria-label="Go back">
              <ArrowLeft className="h-4 w-4" /> Back
            </a>
          </Button>
          <Button asChild>
            <Link to="/dashboard">
              <Home className="h-4 w-4" /> Go to dashboard
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
